
































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import {
    getInvoices,
    getCompanies,
    getInvoiceSendEmail,
    getInvoiceDownloadPdf,
    postInvoice,
    postCancelInvoice,
} from '@/api/api';
import MetaDatatable from '../models/MetaDatatable';
import HeaderDatatable from '../models/HeaderDatatable';
import get from 'lodash/get';
import { Checkbox, Select } from 'ant-design-vue';
import debounce from 'lodash/debounce';
import PaginationDatatable from '../models/PaginationDatatable';
import SorterDatatable from '../models/SorterDatatable';
import User from '../models/User';
import Invoice from '../models/Invoice';
import { getBulkInvoiceExport, getBulkInvoiceExportCsv } from '@/api/api';
import { saveAs } from 'file-saver';
import Company from '../models/Company';
import formatAmount from '../utils/formatAmount';
import { fetchPrescriberSubscribed, fetchPromotors } from '@/utils/filters';
import FilterComponent from '@/components/FilterComponent.vue';
import Datatable from '@/components/Datatable.vue';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import Users from './Users.vue';
import { isEmpty } from 'lodash';
// @ts-ignore
import localeDatePicker from 'ant-design-vue/lib/date-picker/locale/fr_FR';
import { DatePicker } from 'ant-design-vue';
const { RangePicker } = DatePicker;


@Component({
    filters: {
        formatAmount,
    },
    components: {
        Datatable,
        FilterComponent,
        RangePicker,
        'a-checkbox': Checkbox,
        'a-select': Select,
        'a-select-option': Select.Option,
    },
})
export default class Invoices extends Vue {
    selectedInvoiceIds: number[] = [];
    currentPageData: Invoice[] = [];
    isExporting: boolean = false;
    showBulkActions: boolean = false;
    invoicePopUp: Boolean = false;
    yearModel: string = new Date().getFullYear().toString();
    minAmountModel: number | null = null;
    maxAmountModel: number | null = null;
    prescriber_name: string = '';  
    promoter_name: string = '';
    prescriberOptions: any[] = [];   
    promoterOptions: any[] = []; 
    availableYears: number[] = [2022, 2023, 2024, 2025];
    selectedYears: number[] = [];
    isExportingCSV: boolean = false;
    localeDatePicker = localeDatePicker;
    invoice = {
        invoiceType: 'prescriber',
        user: 0,
        promoter: 0,
        description: '',
        amount: 0,
        promoter_edited: '',
        date: '18/12/1998',
        vat_percent: 20
    }

    form = {
        description: {
            error: false,
            errorTxt: 'La description ne peut pas être vide'
        },
        amount: {
            error: false,
            errorTxt: 'Le montant ne doit pas être vide'
        },
        user: {
            error: false,
            errorTxt: 'Vous devez choisir un utilisateur'
        },
        promoter: {
            error: false,
            errorTxt: 'Vous devez choisir un promoteur'
        },
        promoter_edited: {
            error: false
        },
        vat_percent: {
            error: false,
            errorTxt: 'La TVA doit être comprise entre 0 et 100'
        }
    }

    moment = moment;
    dateModel: [moment.Moment | null, moment.Moment | null] | null = null;
    minAmount: number = 0;
    maxAmount: number = 10000000;
    amountRange: number[] = [this.minAmount, this.maxAmount];
    

    onDateFilter(dates: [moment.Moment | null, moment.Moment | null] | null) {
        if (dates && dates[0] && dates[1]) {
            // Si des dates sont sélectionnées, les formater
            const startDate = dates[0].format('YYYY-MM-DD');
            const endDate = dates[1].format('YYYY-MM-DD');
            
            if (this.meta.filters) {
                this.meta.filters.startDate = startDate;
                this.meta.filters.endDate = endDate;
            }
        } else {
            // Si aucune date n'est sélectionnée, mettre les filtres à null
            if (this.meta.filters) {
                this.meta.filters.startDate = null;
                this.meta.filters.endDate = null;
            }
        }
    }

    // Year filter watcher
    @Watch('yearModel', { immediate: true })
    onYearModel() {
        if (this.yearModel) {
            this.meta.filters = {
                ...this.meta.filters,
                year: this.yearModel
            };
            if (this.$refs.datatable) {
                (this.$refs.datatable as any).refresh();
            }
        }
    }

        onAmountChange() {
        if (this.minAmountModel === null && this.maxAmountModel === null) {
            // Si les deux sont vides, pas de filtre
            this.meta.filters.amountRange = null;
        } else {
            // Si au moins un des deux est rempli
            let min = this.minAmountModel !== null ? this.minAmountModel : 0;
            let max = this.maxAmountModel !== null ? this.maxAmountModel : Number.MAX_SAFE_INTEGER;
            
            // Assurez-vous que max est plus grand que min
            if (min > max) {
                max = min;
            }
            
            this.meta.filters.amountRange = [min, max];
        }
        
        if (this.$refs.datatable) {
            (this.$refs.datatable as any).refresh();
        }
    }

    toggleInvoiceType(type: string) {
        const index = this.selectedInvoiceTypes.indexOf(type);
        if (index > -1) {
            // Retirer le type sélectionné
            this.selectedInvoiceTypes.splice(index, 1);
        } else {
            // Sinon, l'ajouter
            this.selectedInvoiceTypes.push(type);
        }
        // Met à jour le filtre dans meta
        this.meta.filters.invoiceTypes = this.selectedInvoiceTypes.length > 0 ? [...this.selectedInvoiceTypes] : [];
        // Rafraîchir la datatable pour réappliquer les filtres
        (this.$refs.datatable as any).refresh();
    }

    availableInvoiceTypes: Array<{ text: string; value: string }> = [
        { text: 'Avoirs', value: 'Avoirs' },
        { text: 'Factures', value: 'Factures' }
    ];
    selectedInvoiceTypes: string[] = [];

        defaultMeta: MetaDatatable = {
        total: 0,
        pages: 0,
        page: 1,
        perPage: 20,
        search: null,
        orderBy: null,
        orderWay: null,
        filters: {
            promoter: undefined,
            prescriber: undefined,
            startDate: null,
            endDate: null,
            year: new Date().getFullYear().toString(), // Add this line
            years: "2025", // Keep for backward compatibility
            invoiceTypes: [],
            amountRange: null
        },
    };
    meta: MetaDatatable = cloneDeep(this.defaultMeta);
    columns: HeaderDatatable[] = [
        {
            title: '',
            dataIndex: 'selection',
            sorter: false,
            width: 50,
            scopedSlots: {
                customRender: 'checkbox',
            },
            fixed: 'left',
        },
        {
            title: 'Numéro',
            dataIndex: 'number',
            sorter: false,
            scopedSlots: {
                customRender: 'number',
            },
        },
        {
            title: 'Prescripteur',
            dataIndex: 'subscription.prescriber',
            sorter: true,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Prescripteur',
            dataIndex: 'user',
            sorter: true,
            scopedSlots: {
                customRender: 'prescriber',
            },
        },
        {
            title: 'Prescripteur (FC Auto)',
            dataIndex: 'automation.user',
            sorter: true,
            scopedSlots: {
                customRender: 'userAuto',
            },
        },
        {
            title: 'Promoteur',
            dataIndex: 'company',
            sorter: true,
            scopedSlots: {
                customRender: 'promoter',
            },
        },
        {
            title: 'Date d\'emission',
            dataIndex: 'created_at',
            sorter: true,
            scopedSlots: {
                customRender: 'date',
            },
        },
        {
            title: 'Montant',
            dataIndex: 'amount',
            sorter: true,
            scopedSlots: {
                customRender: 'amount',
            },
        },
        {
            title: '% TVA',
            dataIndex: 'vat_percent',
            sorter: true,
        },
        {
            title: 'Actions',
            dataIndex: 'action',
            scopedSlots: {
                customRender: 'actions',
            },
            fixed: 'right',
        },
    ];
    async fetch(meta: MetaDatatable) {
        const { data } = await getInvoices({
            ...meta,
            page: meta.page - 1,
        });

        this.currentPageData = data.data || [];

        return data;
    }

    @Watch('meta.page')
onPageChange() {
    this.$nextTick(() => {
        // Update UI after page change
        this.updateBulkActionsVisibility();
    });
}

    @Watch('dateModel')
    onDateModelChange() {
        // This ensures the datatable updates when date filter changes
        const $datatable = this.$refs.datatable as Datatable;
        $datatable.refresh();
    }
    // Watchers for syncing filters
    @Watch('meta.filters', { deep: true, immediate: true })
    syncFilters() {
        if (this.meta.filters) {
            // Sync date filter
            if (this.meta.filters.startDate && this.meta.filters.endDate) {
                this.dateModel = [
                    moment(this.meta.filters.startDate, 'YYYY-MM-DD'),
                    moment(this.meta.filters.endDate, 'YYYY-MM-DD')
                ];
            } else {
                this.dateModel = null;
            }

            // Sync invoice types
            this.selectedInvoiceTypes = this.meta.filters.invoiceTypes ? [...this.meta.filters.invoiceTypes] : [];
            
            // Sync year filter
            if (this.meta.filters.year) {
                this.yearModel = this.meta.filters.year;
            } else {
                this.yearModel = new Date().getFullYear().toString();
            }
            
            this.selectedYears = this.meta.filters.years ? [...this.meta.filters.years] : [];
            
            if (this.meta.filters.amountRange && Array.isArray(this.meta.filters.amountRange) && this.meta.filters.amountRange.length === 2) {
                // Ne définir les valeurs que si elles sont raisonnables (pas les valeurs extrêmes)
                this.minAmountModel = this.meta.filters.amountRange[0] === 0 ? null : this.meta.filters.amountRange[0];
                this.maxAmountModel = this.meta.filters.amountRange[1] >= Number.MAX_SAFE_INTEGER ? null : this.meta.filters.amountRange[1];
                this.amountRange = [...this.meta.filters.amountRange]; // For backward compatibility
            } else {
                this.minAmountModel = null;
                this.maxAmountModel = null;
                this.amountRange = [this.minAmount, this.maxAmount]; // For backward compatibility
            }
            
            // Sync prescriber
            if (this.meta.filters.prescriber) {
                this.prescriberModel = this.meta.filters.prescriber;
            } else {
                this.prescriberModel = undefined;
            }
        }
    }

    onAmountInput(event: KeyboardEvent) {
    // This array contains all the special keys we want to allow
    const allowed = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', '.', ','];
    
    // First check: is it a number?
    if (!isNaN(Number(event.key))) {
        // If it's a number, allow it (return without preventing)
        return;
    }
    
    // Second check: is it a decimal separator (point or comma)?
    if (event.key === '.' || event.key === ',') {
        const value = (event.target as HTMLInputElement).value;
        // Only allow one decimal separator (check for both . and ,)
        if (value.includes('.') || value.includes(',')) {
            event.preventDefault(); // Block if we already have a decimal separator
            return;
        }
        return; // Allow the decimal separator
    }
    
    // Final check: if it's not a number and not in our allowed keys list,
    // prevent it from being typed
    if (!allowed.includes(event.key)) {
        event.preventDefault();
    }
}

get fetchPromoters() {
    return fetchPromotors;
}
    onVatInput(event: KeyboardEvent) {
        const allowed = ['Backspace', 'Delete', 'Tab', 'Escape', 'Enter', '.'];
        
        if (!isNaN(Number(event.key))) {
            // Autorise les chiffres
            return;
        }
        
        if (event.key === '.') {
            const value = (event.target as HTMLInputElement).value;
            // Autorise un seul point décimal
            if (value.includes('.')) {
                event.preventDefault();
                return;
            }
            return;
        }
        
        if (!allowed.includes(event.key)) {
            event.preventDefault();
        }
    }

    async cancelInvoice(invoice: Invoice) {
        const $vs = (this as any).$vs;
        try {
            const { data } = await postCancelInvoice(invoice);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Facture Créée',
                text:
                    'Avoir Crée',
            });
        } catch {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text:
                    'Il y a eu une erreur dans la création de votre avoir',
            });
        }
    }

checkForm() {
    let error = false;

    // Reset errors initially
    this.form.amount.error = false;
    this.form.amount.errorTxt = 'Le montant ne doit pas être vide';

    if (this.invoice.invoiceType == 'promoter') {
        // @ts-ignore
        delete this.invoice.user;
        
        // Check if promoter name is empty
        if (!this.promoter_name || this.promoter_name.trim() === '') {
            error = true;
            this.form.promoter.error = true;
            this.form.promoter.errorTxt = 'Vous devez entrer un nom de promoteur';
        } else {
            this.form.promoter.error = false;
        }
    } else if (this.invoice.invoiceType == 'prescriber') {
        // CORRECTION : Vérifier l'ID utilisateur au lieu du nom
        if (!this.invoice.user || this.invoice.user === 0) {
            error = true;
            this.form.user.error = true;
            this.form.user.errorTxt = 'Vous devez sélectionner un prescripteur';
        } else {
            this.form.user.error = false;
        }
        // @ts-ignore
        delete this.invoice.promoter;
    } else {
        error = true;
    }

    // Validate amount
    if (!this.invoice.amount || this.invoice.amount == 0) {
        this.form.amount.error = true;
        this.form.amount.errorTxt = 'Le montant ne doit pas être vide';
        error = true;
    } else {
        // Check for invalid characters
        const amountString = this.invoice.amount.toString().trim();
        if (/[^0-9.]/.test(amountString)) {
            this.form.amount.error = true;
            this.form.amount.errorTxt = 'Uniquement des chiffres sans espace';
            error = true;
        }
    }

    if (isEmpty(this.invoice.description)) {
        error = true;
        this.form.description.error = true;
    } else {
        this.form.description.error = false;
    }

    if (
        this.invoice.vat_percent === null ||
        this.invoice.vat_percent < 0 ||
        this.invoice.vat_percent > 100
    ) {
        this.form.vat_percent.error = true;
        error = true;
    } else {
        this.form.vat_percent.error = false;
    }

    return error;
}

async createInvoice() {
    // Convertir la virgule en point avant l'envoi
    const amountStr = String(this.invoice.amount).replace(',', '.');
    this.invoice.amount = parseFloat(amountStr) || 0;

    if (this.checkForm()) {
        return;
    }

    // Prepare invoice data with the prescriber/promoter name
    const invoiceData = {
        ...this.invoice,
        prescriber_name: this.prescriber_name,
        promoter_name: this.promoter_name
    };

    const $vs = (this as any).$vs;
    try {
        const { data } = await postInvoice(invoiceData);
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Facture Créée',
            text: 'La facture a bien été Créée',
        });
        this.invoicePopUp = false;
    } catch (error) {
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur',
            text: 'Il y a eu une erreur dans la création de votre facture',
        });
    }
}

    deleteText = {
        confirm: {
            title: `Suppression de la facture`,
            content: `Voulez-vous vraiment supprimer la facture ?`,
        },
        notify: {
            title: 'Facture supprimée',
            content: `La facture a bien été supprimée`,
        },
    };
    editText = {
        notify: {
            title: 'Facture modifiée',
            content: `La facture a bien été modifiée`,
        },
    };

    get fetchPrescribers() {
        return fetchPrescriberSubscribed;
    }

    get yearOptions() {
        const currentYear = new Date().getFullYear();
        const years = [];
        
        // Generate years from current year down to 2022
        for (let year = currentYear; year >= 2020; year--) {
            years.push({
                text: year.toString(),
                value: year.toString()
            });
        }
        
        return years;
    }
get selectedInvoices(): Set<number> {
    return new Set(this.selectedInvoiceIds);
}
get selectedCount(): number {
    return this.selectedInvoiceIds.length;
}

    get currentPageInvoiceIds(): number[] {
        return this.currentPageData ? this.currentPageData.map((invoice: Invoice) => invoice.id).filter((id): id is number => id !== undefined) : [];
    }

    get isAllCurrentPageSelected(): boolean {
        if (this.currentPageInvoiceIds.length === 0) return false;
        return this.currentPageInvoiceIds.every(id => this.selectedInvoices.has(id));
    }

    get isSomeCurrentPageSelected(): boolean {
        return this.currentPageInvoiceIds.some(id => this.selectedInvoices.has(id));
    }

onFilterPrescriber(user_id: number | undefined) {
    if (user_id === undefined) {
        this.invoice.user = 0;
        this.prescriber_name = '';
    } else {
        this.invoice.user = user_id;
        // Trouve le nom du prescripteur
        // Tu peux récupérer le nom depuis le FilterComponent ou faire un appel API
    }
}
    get fetchPromoter() {
        return fetchPromotors;
    }

onFilterPromoter(promoter_id: number | undefined) {
    if (promoter_id === undefined) {
        this.invoice.promoter = 0;
        this.promoter_name = '';
    } else {
        this.invoice.promoter = promoter_id;
        
        // Récupérer le nom depuis le FilterComponent
        const filterComponent = this.$refs.promoterInvoice as any;
        if (filterComponent && filterComponent.items) {
            const selectedPromoter = filterComponent.items.find((item: any) => item.value === promoter_id);
            if (selectedPromoter) {
                this.promoter_name = selectedPromoter.text;
            }
        }
    }
}

    async actionDatatable(ev: {
        action: 'show' | 'edit' | 'delete' | 'add';
        item?: Invoice | null;
    }) {
        const action = ev.action;
        const invoice: Invoice | null = ev.item || null;
        switch (ev.action) {
            case 'edit':
                break;
            case 'delete':
                if (invoice && invoice.id) {
                    this.meta = {
                        total: this.meta.total || 0,
                        pages: this.meta.pages || 0,
                        page: this.meta.page || 0,
                        perPage: this.meta.perPage || 10,
                        search: this.meta.search || null,
                        orderBy: this.meta.orderBy || null,
                        orderWay: this.meta.orderWay || null,
                        filters: this.meta.filters || null,
                    };
                }
                break;
        }
    }

    downloadDialog(invoice: Invoice) {
        if (invoice.id) {
            const $vs = (this as any).$vs;
            getInvoiceDownloadPdf(invoice.id)
                .then((resp: any) => {
                    const fileName = resp.headers['content-disposition'].split(
                        '"'
                    )[1];
                    saveAs(resp.data, fileName);
                })
                .catch(() => {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text:
                            'Une erreur est survenue lors de la récupération du pdf',
                    });
                });
        }
    }
    sendDialog(invoice: Invoice) {
        if (invoice.id) {
            const $vs = (this as any).$vs;
            getInvoiceSendEmail(invoice.id)
                .then(() => {
                    $vs.notify({
                        color: 'success',
                        position: 'top-right',
                        title: 'Succès',
                        text: 'Facture bien envoyée',
                    });
                })
                .catch(() => {
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: "Une erreur est survenue lors de l'envoi du mail",
                    });
                });
        }
    }


toggleInvoiceSelection(invoiceId: number) {
    const index = this.selectedInvoiceIds.indexOf(invoiceId);
    if (index > -1) {
        this.selectedInvoiceIds.splice(index, 1);
    } else {
        this.selectedInvoiceIds.push(invoiceId);
    }
    this.updateBulkActionsVisibility();
}

toggleSelectAllOnPage() {
    if (this.isAllCurrentPageSelected) {
        // Deselect all on current page
        this.currentPageInvoiceIds.forEach(id => {
            const index = this.selectedInvoiceIds.indexOf(id);
            if (index > -1) {
                this.selectedInvoiceIds.splice(index, 1);
            }
        });
    } else {
        // Select all on current page
        this.currentPageInvoiceIds.forEach(id => {
            if (!this.selectedInvoiceIds.includes(id)) {
                this.selectedInvoiceIds.push(id);
            }
        });
    }
    this.updateBulkActionsVisibility();
}

clearAllSelections() {
    this.selectedInvoiceIds = [];
    this.updateBulkActionsVisibility();
}

updateBulkActionsVisibility() {
    this.showBulkActions = this.selectedInvoiceIds.length > 0;
}

async exportSelectedInvoices() {
    if (this.selectedInvoices.size === 0) return;

    this.isExporting = true;
    const $vs = (this as any).$vs;

    try {
        const invoiceIds = Array.from(this.selectedInvoices);
        
        // You'll need to create this API function (see API section below)
        const response = await getBulkInvoiceExport(invoiceIds);
        
        const timestamp = moment().format('YYYY-MM-DD_HH-mm-ss');
        const filename = `factures_export_${timestamp}.zip`;
        
        saveAs(response.data, filename);
        
        $vs.notify({
            color: 'success',
            position: 'top-right',
            title: 'Export réussi',
            text: `${this.selectedInvoices.size} facture(s) exportée(s)`,
        });

        this.clearAllSelections();

    } catch (error) {
        $vs.notify({
            color: 'danger',
            position: 'top-right',
            title: 'Erreur d\'export',
            text: 'Erreur lors de l\'export des factures',
        });
    } finally {
        this.isExporting = false;
    }
}

async exportSelectedInvoicesCSV() {
  if (this.selectedInvoices.size === 0) return;
  this.isExportingCSV = true;

  const $vs = (this as any).$vs;

  try {
    const ids = Array.from(this.selectedInvoices);
    const resp = await getBulkInvoiceExportCsv(ids);
    const filename = `factures_${this.moment().format('YYYY-MM-DD_HH-mm-ss')}.csv`;
    saveAs(resp.data, filename);

    $vs.notify({
      color: 'success',
      position: 'top-right',
      title: 'Export CSV réussi',
      text: `${ids.length} facture(s) exportée(s)`
    });
    this.clearAllSelections();

  } catch {
    $vs.notify({
      color: 'danger',
      position: 'top-right',
      title: 'Erreur',
      text: 'Échec de l’export CSV'
    });
  } finally {
    this.isExportingCSV = false;
  }
}


    async acceptDeleteAlert(invoice: Invoice) {
        const $vs = (this as any).$vs;
        try {
            await this.actionDatatable({ action: 'delete', item: invoice });

            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: this.deleteText.notify.title,
                text: this.deleteText.notify.content,
            });

            const $datatable = this.$refs.datatable as Datatable;
            $datatable.refresh();
        } catch (error) {
            const message = get(
                error,
                'response.data.message',
                `Erreur lors de la suppression de la facture`
            );

            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: message,
            });
        }
    }

    /**
     * Ant design considére null comme une string vide et donc masque le
     * placeholder, du coup il faut mettre à null, puis mettre à undefined
     */
    prescriberModel: string | undefined | null = null;

@Watch('invoicePopUp')
onInvoicePopupChange(newVal: boolean) {
    if (!newVal) {
        // Reset form when popup closes
        this.invoice = {
            invoiceType: 'prescriber',
            user: 0,
            promoter: 0,
            description: '',
            amount: 0,
            promoter_edited: '',
            date: '18/12/1998',
            vat_percent: 20
        };
        this.prescriber_name = '';
        this.promoter_name = '';
        this.prescriberOptions = [];
        this.promoterOptions = [];
        
        // Reset errors
        this.form.description.error = false;
        this.form.amount.error = false;
        this.form.user.error = false;
        this.form.promoter.error = false;
        this.form.promoter_edited.error = false;
        this.form.vat_percent.error = false;
    }
}

@Watch('invoice.invoiceType', { deep: true })
onInvoiceType() {
    // Clear names when switching types
    this.prescriber_name = '';
    this.promoter_name = '';
    this.invoice.user = 0;
    this.invoice.promoter = 0;
    this.prescriberOptions = [];
    this.promoterOptions = [];
    
    if (this.invoice.invoiceType == 'promoter') {
        this.invoice.description = "Mandat :\n\n" +
            "Description et adresse du bien vendu :\n\n" +
            "Nom et prénom acquéreur(s) :\n\n" +
            "PV Appart.Lot FAI :   €\n\n" +
            "Tx rémunération HT/TTC :    € \n\n" +
            "Notaire de l'acte : \n\n" +
            "Date signature de l'acte :";
    } else {
        this.invoice.description = '';
    }
}

    @Watch('meta', { deep: true, immediate: true })
    onMeta() {
        if (this.meta.filters && this.meta.filters.prescriber) {
            this.prescriberModel = this.meta.filters.prescriber;
        } else {
            this.prescriberModel = undefined;
        }
    }

    @Watch('prescriberModel', { immediate: true })
    onPrescriberModel() {
        if (this.prescriberModel) {
            this.meta.filters.prescriber = this.prescriberModel;
        } else if (this.meta.filters) {
            this.meta.filters.prescriber = null;
        }
    }
    created() {
    // Initialize with defaults
    this.yearModel = new Date().getFullYear().toString();
    this.minAmountModel = null;
    this.maxAmountModel = null;
}
}
